export default __webpack_public_path__ + "static/media/insurance-polish.f54e308a.svg";